import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { SharedModule } from '@app/shared/shared.module';
import { BrandMomentComponent } from '@app/shared/ui/brand-moment/brand-moment.component';
import { ButtonComponent } from '@app/shared/ui/button/button.component';
import { DynamicFlowContent } from '../../model/dynamic-flow.types';

@Component({
  selector: 'c-branded-content-step',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, BrandMomentComponent, TranslocoPipe, ButtonComponent],
  templateUrl: './branded-content-step.component.html',
  styleUrl: './branded-content-step.component.scss',
})
export class BrandedContentStepComponent {
  readonly content = input<DynamicFlowContent>();
  readonly buttonLabel = input<string>();
  readonly loading = input(false);
  readonly showPrevious = input(false);
  readonly previousLoading = input(false);

  readonly action = output<void>();
  readonly previous = output<void>();

  protected readonly image = '/assets/branded/img/dynamic-flow-finished-bg.jpg';
  protected readonly checkIcon = faCircleCheck;
}
